export default "__VITE_ASSET__JB$rx6CJ__"